module.exports = __webpack_public_path__ + "img/20190722163215144.6054ac05.png";